export enum TestingContentType {
  WORDFILL = "WORDFILL",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE"
}
